import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import { Button } from "@/components/ui/button";

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <div className="flex flex-col items-center justify-center px-6 py-24 text-center">
        <h1 className="text-7xl font-bold text-[#0f3e3e] mb-4">404</h1>

        <h2 className="text-2xl md:text-3xl font-semibold mb-3">
          Page Not Found
        </h2>

        <p className="text-muted-foreground max-w-md mb-8">
          Sorry, the page you are looking for does not exist or has been moved.
        </p>

        <Link to="/">
          <Button className="bg-[#0f3e3e] text-white hover:bg-[#0f3e3e]/90">
            Go Back to Home
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
